import { getQueryParams } from "@/utils/httpRequest";
import { loanService } from "@/modules/loan/store/services/loan-service";

const getLoanLendersHeatMap = loanService.injectEndpoints({
  endpoints: builder => ({
    getLoanLendersHeatMap: builder.query({
      query: ({ loanId, ...params }) => `loans/${loanId}/lenders-heatmap?${getQueryParams(params)}`,
      providesTags: result =>
        result
          ? [
              ...result.items.map(({ lenderId }) => ({ type: "LoanLendersHeatMap", id: lenderId })),
              { type: "LoanLendersHeatMap", id: "LIST" },
            ]
          : [{ type: "LoanLendersHeatMap", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLoanLendersHeatMapQuery } = getLoanLendersHeatMap;

